<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid content">
          <slot name="header" />
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <div class="h-t-name pull-left">Администрирование</div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content">
          <div class="breadcrumb-wrapp">
            <a href="/administration/">Администрирование</a> >&nbsp;
            <router-link
              :to="{ name: 'AdminStatuses', params: { type: filter.type} }"
            >
              <template v-if="filter.type == 'es'">Чек-лист для экспертного совета</template>
              <template v-else-if="filter.type == 'dz'">Чек-лист для подписания договора займа</template>
              <template v-else> Чек-лист управления отчетными документами</template>
            </router-link>
            >
            <span>{{ adminInfoDocItem.UF_NAME_NO_TAGS }}</span>
          </div>
          <div>
            <router-link
              v-if="programId > 0"

              :to="{ name: 'AdminStatusesColumn', params: {type: filter.type, id: programId} }"
              class="administration-page__item-link"
            >
              <span
                class="header-link-back"
                v-if="!isAdminInfoDocLoading"
              ></span>{{ adminInfoDocItem.UF_NAME_NO_TAGS }}
            </router-link>
            <router-link
              v-else
              :to="{ name: 'AdminStatuses', params: { type: filter.type} }"
              class="administration-page__item-link"
            >
              <span
                class="header-link-back"
                v-if="!isAdminInfoDocLoading"
              ></span>{{ adminInfoDocItem.UF_NAME_NO_TAGS }}
            </router-link>
          </div>

          <div class="wrap admin-form" v-if="!isAdminInfoDocLoading">
            <div v-show="false">
              <div><h4>Наличие шаблона</h4></div>
              <div v-if="isEdit">
                <multiselect
                  v-model="adminInfoDocItem.UF_IS_AVAILABILITY_TEMPLATE"
                  :options="allListValueTemplates"
                  class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                  :multiple="false"
                  placeholder
                  track-by="TEXT"
                  label="TEXT"
                />
              </div>
              <div v-else>
                {{
                  adminInfoDocItem.UF_IS_AVAILABILITY_TEMPLATE
                    ? adminInfoDocItem.UF_IS_AVAILABILITY_TEMPLATE.TEXT
                    : ""
                }}
              </div>
            </div>

            <br />
            <div><h4>Наименование документа</h4></div>
            <div class="controller" v-if="isEdit">
              <textarea-autosize
                class="i-main-style"
                style="min-height: 62px; width: 500px;"
                v-model="adminInfoDocItem.UF_NAME"
              />
            </div>
            <div v-else>
              <div v-html="adminInfoDocItem.UF_NAME"></div>
            </div>

            <div><h4>Дата начала действия документа</h4></div>
            <div class="controller stl-controller-wrapper" v-if="isEdit">
              <datepicker
                v-model="adminInfoDocItem.UF_DATE_START"
                :language="ru"
                inputClass="filter-input-stl filter-input-datapicer i-main-style"
                placeholder="Дата"
                :monday-first="true"
              />
              <template v-if="adminInfoDocItem.UF_DATE_START">
                <i
                  @click="adminInfoDocItem.UF_DATE_START = ''"
                  class="icon-item icon-delete-link"
                  style="height: 16px;"
                ></i>
              </template>
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_DATE_START_TEXT }}
            </div>

            <div><h4>Дата окончания действия документа</h4></div>
            <div class="controller stl-controller-wrapper" v-if="isEdit">
              <div>
                <datepicker
                  v-model="adminInfoDocItem.UF_DATE_END"
                  :language="ru"
                  inputClass="filter-input-stl filter-input-datapicer i-main-style"
                  placeholder="Дата"
                  :monday-first="true"
                />
              </div>
              <template v-if="adminInfoDocItem.UF_DATE_END">
                <i
                  @click="adminInfoDocItem.UF_DATE_END = ''"
                  class="icon-item icon-delete-link"
                  style="height: 16px;"
                ></i>
              </template>
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_DATE_END_TEXT }}
            </div>


            <br />
            <div><h4>Раздел ЭС</h4></div>
            <div v-if="adminInfoDocItem.UF_TYPE_DOC_ID">
              <span class="link">{{ getSectionName }}</span>
            </div>
            <div v-else>
              <span class="link">Документ не выбран</span>
            </div>


            <!--<div>Заявка на изменение</div>
            <div>
              <router-link
                :to="{ name: 'AdminStatuses' }"
                class="administration-page__item-link"
              >
                Направить заявку на изменение
              </router-link>
            </div>-->

            <div style="display: flex;">
              <div>
                <h4>
                  Акцепты на ЭС
                  <i
                    @click="isAcceptModalView = true"
                    class="header-link-setting"
                  />
                </h4>
              </div>
            </div>
            <div
              v-for="(accept,
              index) in adminInfoDocItem.ACCEPTANCES_DATA_BY_PROG_ID"
              :key="`${accept.UF_STATUS_NAME}-${index}`"
            >
              <div v-if="accept.UF_GROUP_ACCEPT_LIST_ARR.length > 0">
                <b>{{ accept.UF_STATUS_NAME }} </b> -
                {{ getNamesForAccepts(accept.UF_GROUP_ACCEPT_LIST_ARR) }}
              </div>
            </div>

            <div style="display: flex">
              <div>
                <h4>
                  Статусы загрузки (ЭС)
                  <i
                    @click="isStatusModalView = true"
                    class="header-link-setting"
                  />
                </h4>
              </div>
            </div>
            <div
              v-for="(status, index) in adminInfoDocItem.PROGRAM_STATUS_TEXT"
              :key="`${status.PROGRAM_NAME}-${index}`"
            >
              <div>
                <b>{{ status.PROGRAM_NAME }} </b> - {{ status.STATUS_NAME }}
              </div>
            </div>

            <div style="display: flex; padding-top: 6px;">
              <div>
                <h4>
                  Настройки документа в разрезе программ (ЭС)
                  <i
                    @click="isStatusModalSettingESView = true"
                    class="header-link-setting"
                  />
                </h4>
              </div>
            </div>

            <div><h4>Допустимое расширение файлов (ЭС)</h4></div>
            <div v-if="isEdit">
              <multiselect
                v-model="adminInfoDocItem.UF_EXT_ARR"
                :options="allExtList"
                class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                style="min-height: 26px; width: 500px;"
                :multiple="true"
                placeholder
                :limit="30"
                track-by="ID"
                label="NAME"
              >
                <span slot="noOptions">Расширения не найдены</span>
                <span slot="noResult">Расщирения не найдены</span>
              </multiselect>
            </div>
            <div v-else>
              {{ getNamesForAccepts(adminInfoDocItem.UF_EXT_ARR) }}
            </div>

            <div><h4>Множественный документ (ЭС)</h4></div>
            <div v-if="isEdit">
              <select
                class="sel-dropdown i-main-style i-wid-13"
                v-model="adminInfoDocItem.UF_IS_MULTY"
              >
                <option :value="1">Да</option>
                <option :value="0">Нет</option>
              </select>
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_IS_MULTY ? "Да" : "Нет" }}
            </div>

            <div><h4>Загрузка с ЭЦП (ЭС)</h4></div>
            <div v-if="isEdit">
              <select
                class="sel-dropdown i-main-style i-wid-13"
                v-model="adminInfoDocItem.UF_IS_ECP"
              >
                <option :value="1">Да</option>
                <option :value="0">Нет</option>
              </select>
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_IS_ECP ? "Да" : "Нет" }}
            </div>

            <div><h4>Обязательность документа (ЭС)</h4></div>
            <div v-if="isEdit">
              <select
                class="sel-dropdown i-main-style i-wid-13"
                v-model="adminInfoDocItem.UF_IS_REQ"
              >
                <option :value="1">Да</option>
                <option :value="0">Нет</option>
              </select>
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_IS_REQ ? "Да" : "Нет" }}
            </div>

            <div><h4>Загружающий (ЭС)</h4></div>
            <div v-if="isEdit">
              <multiselect
                v-model="adminInfoDocItem.UF_GROUP_LOAD_USER_ARR"
                :options="allGroupUserListComp"
                class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                placeholder
                :multiple="true"
                track-by="ID"
                label="NAME"
              >
                <span slot="noOptions">Загружающий не найден</span>
                <span slot="noResult">Загружающий не найден</span>
              </multiselect>
            </div>
            <div v-else>
              {{ getNamesForAccepts(adminInfoDocItem.UF_GROUP_LOAD_USER_ARR) }}
            </div>

            <div><h4>Подсказка (сноска) (ЭС)</h4></div>
            <div v-if="isEdit">
              <textarea-autosize
                class="i-main-style"
                style="min-height: 62px; width: 500px;"
                v-model="adminInfoDocItem.UF_HELP_ES"
              />
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_HELP_ES }}
            </div>

            <div><h4>Ссылка на шаблон (ЭС)</h4></div>
            <div class="controller" v-if="isEdit">
              <input
                type="text"
                v-model="adminInfoDocItem.UF_SHABLON_LINK_ES"
                class="i-main-style"
              />
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_SHABLON_LINK_ES }}
            </div>

            <div v-show="adminInfoDocItem.isAdmin == 1">
              <div><h4>Символьный код для ЭС</h4></div>
              <div class="controller" v-if="isEdit">
                <input
                  type="text"
                  :disabled="(adminInfoDocItem.UF_TYPE_DOC_ID)?true:false"
                  v-model="adminInfoDocItem.UF_TYPE_DOC_CODE"
                  class="i-main-style"
                />
              </div>
              <div v-else>
                {{ adminInfoDocItem.UF_TYPE_DOC_CODE }}
              </div>
              <div><h4>IDLK для ЭС</h4></div>
              <div class="controller" v-if="isEdit">
                <input
                  v-model="adminInfoDocItem.UF_TYPE_DOC_ID"
                  @keypress="isNumber($event)"
                  :disabled="(adminInfoDocItem.UF_TYPE_DOC_ID)?true:false"
                  type="text"
                  class="i-main-style"
                />
              </div>
              <div v-else>
                {{ adminInfoDocItem.UF_TYPE_DOC_ID }}
              </div>
            </div>

            <br />
            <div><h4>Раздел ДЗ</h4></div>
            <div v-if="adminInfoDocItem.UF_TYPE_DOC_DZ_ID">
              <span class="link">{{ getSectionNameDZ }}</span>
            </div>
            <div v-else>
              <span class="link">Документ не выбран</span>
            </div>

            <div style="display: flex; padding-top: 6px;">
              <div>
                <h4>
                  Вхождение в чек-лист программ и настройки документа в разрезе программ (ДЗ)
                  <i
                    @click="isStatusModalSettingDZView = true"
                    class="header-link-setting"
                  />
                </h4>
              </div>
            </div>
              <template
                v-for="(text, index) in adminInfoDocItem.PROGRAM_DZ_SETTING"
              >
                <div
                  v-if="text.UF_IS_CHECK_LIST === 1"
                  :key="`${index}-${text.PROGRAM_NAME}`">
                  <b>{{ text.PROGRAM_NAME }}</b>
                </div>
              </template>

            <div><h4>Допустимое расширение файлов для подписания (ДЗ)</h4></div>
            <div v-if="isEdit">
              <multiselect
                v-model="adminInfoDocItem.UF_EXT_DZ_ARR"
                :options="allExtList"
                class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                style="min-height: 26px; width: 500px;"
                :multiple="true"
                placeholder
                :limit="30"
                track-by="ID"
                label="NAME"
              >
                <span slot="noOptions">Расширения не найдены</span>
                <span slot="noResult">Расщирения не найдены</span>
              </multiselect>
            </div>
            <div v-else>
              {{ getNamesForAccepts(adminInfoDocItem.UF_EXT_DZ_ARR) }}
            </div>
            <div><h4>Вид документа на подписании (ДЗ)</h4></div>
            <div v-if="isEdit">
              <multiselect
                v-model="adminInfoDocItem.UF_VID_DOC_DZ_ARR"
                :options="allVidDocDZ"
                class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                style="min-height: 26px; width: 500px;"
                :multiple="true"
                placeholder
                :limit="30"
                track-by="ID"
                label="NAME"
              >
                <span slot="noOptions">Виды не найдены</span>
                <span slot="noResult">Виды не найдены</span>
              </multiselect>
            </div>
            <div v-else>
              {{ getNamesForAccepts(adminInfoDocItem.UF_EXT_DZ_ARR) }}
            </div>

            <div><h4>Подсказка (сноска) (ДЗ)</h4></div>
            <div v-if="isEdit">
              <textarea-autosize
                class="i-main-style"
                style="min-height: 62px; width: 500px;"
                v-model="adminInfoDocItem.UF_HELP_DZ"
              />
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_HELP_DZ }}
            </div>

            <div><h4>Ссылка на шаблон (ДЗ)</h4></div>
            <div class="controller" v-if="isEdit">
              <input
                type="text"
                v-model="adminInfoDocItem.UF_SHABLON_LINK_DZ"
                class="i-main-style"
              />
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_SHABLON_LINK_DZ }}
            </div>

            <div v-show="adminInfoDocItem.isAdmin == 1">
              <div><h4>Символьный код для подписания (ДЗ)</h4></div>
              <div class="controller" v-if="isEdit">
                <input
                  type="text"
                  :disabled="(adminInfoDocItem.UF_TYPE_DOC_DZ_ID)?true:false"
                  v-model="adminInfoDocItem.UF_TYPE_DOC_DZ_CODE"
                  class="i-main-style"
                />
              </div>
              <div v-else>
                {{ adminInfoDocItem.UF_TYPE_DOC_DZ_CODE }}
              </div>
              <div><h4>IDLK для подписания (ДЗ)</h4></div>
              <div class="controller" v-if="isEdit">
                <input
                  v-model="adminInfoDocItem.UF_TYPE_DOC_DZ_ID"
                  @keypress="isNumber($event)"
                  :disabled="(adminInfoDocItem.UF_TYPE_DOC_DZ_ID)?true:false"
                  type="text"
                  class="i-main-style"
                />
              </div>
              <div v-else>
                {{ adminInfoDocItem.UF_TYPE_DOC_DZ_ID }}
              </div>
            </div>

            <div v-show="false">
              <div><h4>Предыдущая версия</h4></div>
              <div v-if="isEdit">
                <multiselect
                  v-model="adminInfoDocItem.UF_LAST_VERSION_ARR"
                  :options="allTypeListComp"
                  class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                  :multiple="false"
                  placeholder
                  track-by="ID"
                  label="NAME"
                >
                  <span slot="noOptions">Версия не найдена</span>
                  <span slot="noResult">Версия не найдена</span>
                </multiselect>
              </div>
              <div v-else>
                {{ getNamesForAccepts(adminInfoDocItem.UF_LAST_VERSION_ARR) }}
              </div>
            </div>


            <br />
            <div><h4>Общие настройки</h4></div>
            <div><h4>Сортировка</h4></div>
            <div class="controller" v-if="isEdit">
              <input
                v-model="adminInfoDocItem.UF_SORT"
                @keypress="isNumber($event)"
                type="text"
                class="i-main-style"
              />
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_SORT }}
            </div>


            <div><h4>Примечание</h4></div>
            <div v-if="isEdit">
              <textarea-autosize
                class="i-main-style"
                style="min-height: 42px; width: 500px;"
                v-model="adminInfoDocItem.UF_DESCRIPTION"
              />
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_DESCRIPTION }}
            </div>
            <div>
              <h4>
                Комментарии (<a
                style="text-decoration: underline;"
                href="javascript:void(0);"
                @click="showCommentDialog = true"
              >особые условия</a
              >)
              </h4>
            </div>
            <div v-if="isEdit">
              <textarea-autosize
                class="i-main-style"
                style="min-height: 42px; width: 500px;"
                v-model="adminInfoDocItem.UF_COMMENTS"
              />
            </div>
            <div v-else>
              {{ adminInfoDocItem.UF_COMMENTS }}
            </div>


            <div v-show="false">
              <div><h4>Наличие в официальном чек-листе</h4></div>
              <div v-if="isEdit">
                <select
                  class="sel-dropdown i-main-style i-wid-13"
                  v-model="adminInfoDocItem.UF_IS_OFFICIAL_CHECKLIST"
                >
                  <option :value="1">Да</option>
                  <option :value="0">Нет</option>
                </select>
              </div>
              <div v-else>
                {{ adminInfoDocItem.UF_IS_OFFICIAL_CHECKLIST ? "Да" : "Нет" }}
              </div>
            </div>
            <div v-show="false">
              <div><h4>Предоставляется при выдаче займа</h4></div>
              <div v-if="isEdit">
                <select
                  class="sel-dropdown i-main-style i-wid-13"
                  v-model="adminInfoDocItem.UF_IS_EXTRADITE_LOAN"
                >
                  <option :value="1">Да</option>
                  <option :value="0">Нет</option>
                </select>
              </div>
              <div v-else>
                {{ adminInfoDocItem.UF_IS_EXTRADITE_LOAN ? "Да" : "Нет" }}
              </div>
            </div>
            <div v-show="false">
              <div>
                <h4>
                  Программы в чек-листе ДЗ (если документ присутствует только в
                  ДЗ)
                </h4>
              </div>
              <div v-if="isEdit">
                <multiselect
                  v-model="adminInfoDocItem.UF_DZ_SUPPORT_PROGRAM_ID_ARR"
                  :options="allProgrammList"
                  class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                  placeholder
                  :multiple="true"
                  track-by="ID"
                  label="NAME"
                >
                  <span slot="noOptions">Загружающий не найден</span>
                  <span slot="noResult">Загружающий не найден</span>
                </multiselect>
              </div>
              <div v-else>
                {{
                  getNamesForAccepts(
                    adminInfoDocItem.UF_DZ_SUPPORT_PROGRAM_ID_ARR
                  )
                }}
              </div>
            </div>
          </div>
          <div v-else>Загрузка данных...</div>
        </div>
      </div>
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div v-if="isEdit" class="footer-sabmit">
          <button
            @click="fetchList"
            class="but-style but-ext screenplay-container"
            style="height: 30px;"
          >
            Отмена
          </button>

          <button
            @click="saveInfo"
            style="height: 30px;"
            class="but-style but-save screenplay-container"
          >
            Сохранить
          </button>
        </div>

        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div class="pull-right"></div>
        </div>
      </div>
    </div>

    <!--  Модальное окно акцепты  -->
    <div
      class="modal fade in"
      :class="{ show: isAcceptModalView }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-large" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Настройка Акцепты</h4>
          </div>
          <div class="modal-body">
            <div
              class="table-responsive content i-main-style"
              style="padding-left: 0; padding-right: 0;"
            >
              <table
                class="table ackcept-table-modal"
                style="min-height: 240px;"
              >
                <thead>
                <tr>
                  <th
                    v-for="program in statusAcceptancesProgramList"
                    :key="
                        `${program.STAGE_SMALL_NAME}-${program.ID}-${program.ID}`
                      "
                  >
                    {{ program.STAGE_SMALL_NAME }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td
                    v-for="(item,
                      index) in adminInfoDocItem.ACCEPTANCES_DATA_BY_PROG_ID"
                    :key="`item-${index}-item`"
                  >
                    <template v-if="isEdit">
                      <multiselect
                        v-model="item.UF_GROUP_ACCEPT_LIST_ARR"
                        :options="allGroupUserListComp"
                        class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline table-multiselect-modal"
                        style="min-height: 32px; min-width: 150px;"
                        :multiple="true"
                        placeholder
                        :limit="30"
                        track-by="ID"
                        label="NAME"
                      >
                        <span slot="noOptions">Группы не найдены</span>
                        <span slot="noResult">Группы не найдены</span>
                      </multiselect>
                    </template>
                    <template v-else>
                      {{ getNamesForAccepts(item.UF_GROUP_ACCEPT_LIST_ARR) }}
                    </template>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="isEdit" class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="cancelModalHandle"
            >
              Отмена
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="saveAcceptHandle"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--    Модальное окно статусы загрузки ЭС-->
    <div
      class="modal fade in"
      :class="{ show: isStatusModalView }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-full" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Настройка статусов загрузки</h4>
          </div>
          <div class="modal-body">
            <div class="table-responsive" style="padding-left: 0;">
              <table
                class="table ackcept-table-modal table-top-bd_fix"
                style="min-height: 240px;"
              >
                <thead style="top: 0px;">
                <tr>
                  <th>Наименование программы</th>
                  <th
                    v-for="status in statusLoadProgramList"
                    :key="`${status.NAME}-${status.ID}-item`"
                  >
                    {{ status.NAME }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(program, idx) in programList"
                  :key="`item-${idx}-${program.ID}`"
                >
                  <td>{{ program.NAME }}</td>
                  <td
                    v-for="(item, idx) in adminInfoDocItem
                        .STATUS_DATA_BY_PROG_ID[program.ID]"
                    :key="`${idx}-item-${item.UF_STATUS_ID}`"
                  >
                    <input
                      type="checkbox"
                      v-model="item.VALUE"
                      :disabled="!isEdit"
                      v-show="
                          program.IS_REGIONAL_PROGRAMM ||
                            (!program.IS_REGIONAL_PROGRAMM &&
                              !item.IS_REGIONAL_STATUS)
                        "
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="isEdit" class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="cancelModalHandle"
            >
              Отмена
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="saveStatusHandle"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Изменение полей настроек проекта -->
    <div
      class="modal fade in show"
      v-if="showCommentDialog"
      tabindex="-1"
      role="dialog"
    >
      <form>
        <div class="modal-dialog modal-new-style" role="document">
          <div class="modal-content modal-content-middle">
            <div class="modal-header">
              <button type="button" class="close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Комментарии</h4>
            </div>

            <div class="modal-body">
              <div class="form-group">
                <label>История комментариев:</label>
                <div
                  class="modal-history-statys"
                  v-for="(item, index) in commentsList[adminInfoDocItem.ID]"
                  :key="index"
                >
                  <div
                    class="modal-history-statys__name"
                    style="padding:4px 0; font-size:11px; border-bottom: 1px solid #ccc;"
                  >
                    {{ item.MANAGER_INFO }} - {{ item.DATE_SAVE }} <br />
                    <span>{{ item.UF_COMMENTS }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="butt-stl butt-black"
                type="button"
                @click="showCommentDialog = false"
              >
                закрыть
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </form>
    </div>
    <!-- /.modal -->

    <!--    Модальное окно настроек по программам  ЭС-->
    <div
      class="modal fade in"
      :class="{ show: isStatusModalSettingESView }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-full" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Настройки документа в разрезе программ (ЭС)</h4>
          </div>
          <div class="modal-body">
            <div class="table-responsive" style="padding-left: 0;">
              <table
                class="table ackcept-table-modal table-top-bd_fix content"
                style="min-height: 240px;"
              >
                <thead style="top: 0px;">
                <tr>
                  <th>Наименование программы</th>
                  <th>Наименование документа <br/>(если отличается от базового наименования)</th>
                  <th>Сортировка документа</th>
                  <th>Подсказка (сноска)</th>
                  <th>Ссылка на шаблон</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(program, idx) in adminInfoDocItem.PROGRAM_ES_SETTING"
                  :key="`item-${idx}-${program.ID}`"
                >
                  <td>{{ program.PROGRAM_NAME }}</td>
                  <td style="width: 120px;">
                    <textarea
                      v-model="program.UF_NAME"
                      class="i-main-style"
                      style="min-height: 52px; min-width: 200px;"
                    ></textarea>
                  </td>
                  <td style="width: 120px;">
                    <input
                      type="text"
                      v-model="program.UF_SORT"
                      class="i-main-style"
                      style="max-width: 120px;"
                      :disabled="!isEdit"
                    />
                  </td>
                  <td>
                    <textarea
                      v-model="program.UF_HELP"
                      class="i-main-style"
                      style="min-height: 52px; min-width: 200px;"
                    ></textarea>
                  </td>
                  <td>
                    <input
                      type="text"
                      class="i-main-style"
                      v-model="program.UF_SHABLON_LINK"
                      style="min-width: 250px;"
                      :disabled="!isEdit"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="isEdit" class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="cancelModalSettingES"
            >
              Отмена
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="saveSettingES"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--    Модальное окно настроек по программам  ДЗ-->
    <div
      class="modal fade in"
      :class="{ show: isStatusModalSettingDZView }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-full" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Настройки документа в разрезе программ (ДЗ)</h4>
          </div>
          <div class="modal-body">
            <div class="table-responsive" style="padding-left: 0;">
              <table
                class="table ackcept-table-modal table-top-bd_fix content"
                style="min-height: 240px;"
              >
                <thead style="top: 0px;">
                <tr>
                  <th>Наименование программы</th>
                  <th>Входит в чек-лист</th>
                  <th>Наименование документа <br/>(если отличается от базового наименования)</th>
                  <th>Сортировка документа</th>
                  <th>Подсказка (сноска)</th>
                  <th>Ссылка на шаблон</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(program, idx) in adminInfoDocItem.PROGRAM_DZ_SETTING"
                  :key="`item-${idx}-${program.PROGRAM_ID}`"
                >
                  <td>{{ program.PROGRAM_NAME }}</td>
                  <td class="cnt" style="width: 110px;">
                    <input
                      type="checkbox"
                      v-model="program.UF_IS_CHECK_LIST"
                      class="i-main-style"
                      :disabled="!isEdit"
                    />
                  </td>
                  <td style="width: 120px;">
                    <textarea
                      v-model="program.UF_NAME"
                      class="i-main-style"
                      style="min-height: 52px; min-width: 200px;"
                    ></textarea>
                  </td>
                  <td style="width: 120px;">
                    <input
                      type="text"
                      v-model="program.UF_SORT"
                      class="i-main-style"
                      style="max-width: 120px;"
                      :disabled="!isEdit"
                    />


                  </td>
                  <td>
                    <textarea
                      class="i-main-style"
                      v-model="program.UF_HELP"
                      style="min-height: 52px; min-width: 200px;"
                    ></textarea>
                  </td>
                  <td>
                    <input
                      type="text"
                      class="i-main-style"
                      v-model="program.UF_SHABLON_LINK"
                      style="min-width: 250px;"
                      :disabled="!isEdit"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="isEdit" class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="cancelModalSettingDZ"
            >
              Отмена
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="saveSettingDZ"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </div>

  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_ADMIN_INFO_DOC_LIST,
  SET_IS_VIEW_ALL_EXPERTISE,
  SET_MAIN_MENU
} from "@/store/actions.type";
import { AdminService, ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import { ru } from "vuejs-datepicker/dist/locale";

export default {
  name: "InfoDocument",
  title: "Статусы загрузки документов",
  components: {
    Datepicker,
    Multiselect
  },
  data() {
    return {
      siteUrl: "",
      isEdit: false,
      isAcceptModalView: false,
      isStatusModalView: false,
      isStatusModalSettingESView: false,
      isStatusModalSettingDZView: false,
      ru: ru,
      showCommentDialog: false,
      filter: {
        type: (this.$route.query.type && this.$route.query.type !== "") ? this.$route.query.type : "es"
      },
      programId: (this.$route.query.programId && parseInt(this.$route.query.programId) > 0) ? parseInt(this.$route.query.programId) : 0
    };
  },

  computed: {
    ...mapGetters([
      "adminInfoDocItem",
      "allGroupUserList",
      "allListValueTemplates",
      "adminStatusDocsItems",
      "allTypeList",
      "allVidDocDZ",
      "allExtList",
      "programList",
      "commentListByType",
      "commentsList",
      "statusAcceptancesProgramList",
      "statusLoadProgramList",
      "isAdminInfoDocLoading"
    ]),
    allGroupUserListComp() {
      return Object.values(this.allGroupUserList) || [];
    },
    allProgrammList() {
      return Object.values(this.programList) || [];
    },
    allTypeListComp() {
      return Object.values(this.allTypeList) || [];
    },
    getSectionName() {
      if (
        !this.isAdminInfoDocLoading &&
        this.adminInfoDocItem.SECTION &&
        this.adminInfoDocItem.SECTION.NAME
      ) {
        return this.adminInfoDocItem.SECTION.NAME;
      }
      return "";
    },
    getSectionNameDZ() {
      if (
        !this.isAdminInfoDocLoading &&
        this.adminInfoDocItem.SECTION_DZ &&
        this.adminInfoDocItem.SECTION_DZ.NAME
      ) {
        return this.adminInfoDocItem.SECTION_DZ.NAME;
      }
      return "";
    }
  },

  beforeRouteLeave(to, from, next) {
    this.adminStatusDocsItems = {};
    next();
  },

  mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.isEdit = data.SETTING_RULES_ADMIN_MODULE.REPORTING_DOCUMENTS_IS_EDIT;
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });
        }
      } else {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });
        }
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
    });

    this.fetchList();
  },

  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    fetchList() {
      this.$store.dispatch(FETCH_ADMIN_INFO_DOC_LIST, this.$route.params.id);
    },
    getNamesForAccepts(arr) {
      if ((arr && arr.length === 0) || arr === undefined) {
        return "";
      }
      return arr.map(u => u.NAME).join(", ");
    },
    cancelModalHandle() {
      this.isAcceptModalView = false;
      this.isStatusModalView = false;
      //this.fetchList();
    },
    saveInfo() {
      return AdminService.setInfoDocument(this.$route.params.id, {
        TYPE_SAVE: "record_type_save",
        fields: this.adminInfoDocItem
      })
        .then(({ data }) => {
          if (!data.error) {
            this.$toasted.show("Сохранено", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
          this.isAcceptModalView = false;
          this.isStatusModalView = false;
          this.fetchList();
        }, this)
        .catch(err => {
          console.log(err);
        });
    },
    saveAcceptHandle() {
      return AdminService.setInfoDocument(this.$route.params.id, {
        TYPE_SAVE: "acceptance_save",
        fields: this.adminInfoDocItem
      })
        .then(({ data }) => {
          if (!data.error) {
            this.$toasted.show("Сохранено", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
          this.isAcceptModalView = false;
          this.isStatusModalView = false;
          this.fetchList();
        }, this)
        .catch(err => {
          console.log(err);
        });
    },
    saveStatusHandle() {
      return AdminService.setInfoDocument(this.$route.params.id, {
        TYPE_SAVE: "status_save",
        fields: this.adminInfoDocItem
      })
        .then(({ data }) => {
          if (!data.error) {
            this.$toasted.show("Сохранено", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
          this.isAcceptModalView = false;
          this.isStatusModalView = false;
          this.fetchList();
        }, this)
        .catch(err => {
          console.log(err);
        });
    },

    cancelModalSettingES() {
      this.isStatusModalSettingESView = false;
    },
    saveSettingES() {
      return AdminService.setInfoDocument(this.$route.params.id, {
        TYPE_SAVE: "save_program_setting_es",
        fields: this.adminInfoDocItem
      })
        .then(({ data }) => {
          if (!data.error) {
            this.$toasted.show("Сохранено", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
          this.isAcceptModalView = false;
          this.isStatusModalView = false;
          this.isStatusModalSettingESView = false;
          this.isStatusModalSettingDZView = false;
          this.fetchList();
        }, this)
        .catch(err => {
          console.log(err);
        });
    },

    cancelModalSettingDZ() {
      this.isStatusModalSettingDZView = false;
    },
    saveSettingDZ() {
      return AdminService.setInfoDocument(this.$route.params.id, {
        TYPE_SAVE: "save_program_setting_dz",
        fields: this.adminInfoDocItem
      })
        .then(({ data }) => {
          if (!data.error) {
            this.$toasted.show("Сохранено", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
          this.isAcceptModalView = false;
          this.isStatusModalView = false;
          this.isStatusModalSettingESView = false;
          this.isStatusModalSettingDZView = false;
          this.fetchList();
        }, this)
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
  max-height: 600px;
  -webkit-overflow-scrolling: touch;
}
</style>
